import { render, staticRenderFns } from "./SliceNotFound.vue?vue&type=template&id=1c69c8a8"
import script from "./SliceNotFound.vue?vue&type=script&lang=js"
export * from "./SliceNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports